import { DS_breakpoints as coreBreakpoints } from 'mui/base/theme/DS_Tokens/core';
export const layoutVerticalGapStyles = ({ theme }) => `

    margin-top: 40px;
    margin-bottom: 50px;
  
  ${theme.breakpoints.up('lg')} {
    margin-top: ${theme.DS_spacing(['xs'])};
    margin-bottom: ${theme.DS_spacing(['sm'])};
  }
     
`;

// export const layoutVerticalGapStyles = ({ theme }) => `
//     margin-bottom: 7.5rem;
// `;

// style for DS_Hero and ds_Basic_Hero, to be replaced by layoutVerticalGapStyles once we overwrite the global styles
export const layoutVerticalGapStylesMinusGlobalGap = ({ theme }) => `
    
    margin-top: 2.5rem;
    margin-bottom: 0;
  
  ${theme.breakpoints.up('md')} {
    margin-top: 3.75rem;
    margin-bottom: 0.9rem;
  }
  ${theme.breakpoints.up('lg')} {
    margin-top: 0.75rem;
    padding-top: ${theme.DS_spacing(['xxxl'])};
    padding-bottom: ${theme.DS_spacing(['xxl'])};
  }
`;

export const layoutHorizontalGapStyles = ({ theme }) => `

   margin-left: ${theme.DS_spacing(['md'])};
   margin-right: ${theme.DS_spacing(['md'])};
  
  ${theme.breakpoints.up('md')} {
    margin-left: ${theme.DS_spacing(['lgx'])};
    margin-right: ${theme.DS_spacing(['lgx'])};
  }
  `;

export const maxWidth = `
   max-width: ${coreBreakpoints['xl']}em;
   margin: 0 auto;
   width: 100%;
  `;

export const hideScrollBar = `
   ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; 
    scrollbar-width: none;
`;

export const slideLayout = `
     display: flex;
    flex-flow: row nowrap;
    gap: 0.75rem;
    overflow-x: auto;
    margin-bottom: -40px;
    padding-bottom: 40px;

`;

export const resetStylesMui = `
  box-shadow: none !important;
  padding: unset;
  border: none;
  margin-bottom: unset;
`;
